import { makeStyles } from "@material-ui/core/styles";

export const useAddRestaurantStyles = () => {
  const useStyles = makeStyles((theme) => ({
    mt10: {
      marginTop: 10,
    },
    mt20: {
      marginTop: 20,
    },
    mt40: {
      marginTop: 40,
    },
    ml20: {
      marginLeft: 20,
    },
    mr5: {
      marginRight: 5,
    },
    textFieldStyles: {
      width: "100%",
      "&:focus": {
        border: "1px solid #476b6b",
      },
    },
    iconStyles: { height: 200, width: 200 },
  }));
  const classes = useStyles();
  return classes;
};
